import { defineNuxtPlugin } from '#imports'

import { queueExposure } from '../experiment/client'

/**
 * Listens to the `experiments:exposure` Nuxt hook fired by
 * `nuxt-module-experiments` (design.md DD10) and forwards each key to the
 * Amplitude Experiment client (`../experiment/client`), which queues it
 * until the consent gate opens.
 *
 * `nuxtApp` is deliberately untyped (`any`), not `NuxtApp` from `nuxt/app`:
 * this monorepo resolves duplicate peer-dependency copies of `nuxt@4.4.8`,
 * so an explicitly-imported `NuxtApp` type here mismatches the instance
 * `defineNuxtPlugin` (via `#imports`) expects in at least some consuming
 * apps, and `'experiments:exposure'` itself — declared via
 * `declare module '#app'` in `nuxt-module-experiments/src/experiments.d.ts`
 * — isn't visible across that same instance boundary either. This is the
 * same pre-existing cross-package Nuxt-hook ambient-type limitation
 * already present for other custom hooks in this monorepo (e.g.
 * `browsing-history:update`), not something specific to this hook.
 */
export function setupExposureTracking(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- see comment above
  nuxtApp: any,
): void {
  if (import.meta.server) return

  nuxtApp.hook('experiments:exposure', (key: string) => {
    queueExposure(key)
  })
}

export default defineNuxtPlugin(setupExposureTracking)
